import './Locations.css';
import Ski from './Ski'

function Incline() {
  return (
    <div className="Incline">
      <h3>Incline Village</h3>
      
      <p>Cyane is so entranced by the moon she barely notices her ski coach holding out the wooden torch. <i>His face has faded, I wonder if he would still hear me if—</i></p>

      <p>“Cyane.”</p>

      <p>“Oh, sorry.”</p>

      <p>Cyane grabs the torch holding it away from her face as it spits a few sparks onto her mittens. 
        Ripping her gaze away from the moon, she looks down at the snowy hill before her, it's perfect. 
        Untouched powder. The mountain has been closed the entire day in preparation for the Uller Festival, 
        and now under fierce moonlight, the hill glitters in frosted silver. The lights of the lodge at the 
        bottom have been replaced by more torches, and in the flickering shadows, Cyane can just make out 
        the giant pile of old skis, poles, boots, and boards that she will set alight.</p>

      <p>“Do you think we are old enough to be allowed to do this?” 
        Kore guides her own skis to settle above Cyane. Her eyes sparkle like snow in moonlight.</p>

      <p>“It's Tahoe. We can do anything.” Cyane smiles with glee as she waves her torch through 
        the air, sparks flying about and fizzing in the snow.</p>

      <p>“You lose another one?” Kore points at her own mouth with her mitten. Cyane's tongue 
        explores the newly made gap in her teeth, feeling where her smooth gum turns into mushy 
        and metallic tissue. She nods.</p>

      <p>“My dad made this awesome jump for our sled run and I ran into a tree.” Now it's Kore's 
        turn to nod.</p>

      <p>A dull roar from the crowd at the base of the hill reaches up to Cyane. She glances back 
        at her coach, who nods. Time to go.</p>
      
      <p>Pointing their skis downhill, Cyane and Kore lead the trail of children with fire down the 
        mountain, making</p>

      <div className="PrettyText">
        <Ski></Ski>
      </div>

      <p>She and Kore, hand in hand, becoming the twinkling misty spray of snow preceding an avalanche. 
        The flames sputter and flash, clinging to life upon the wooden torches as the two fling themselves 
        into the steep powder with delight, dancing through the night air as if possessed by Uller himself.</p>

      <p>And then it is over, the hill conquered and their snowy bodies becoming once again human as they reach 
        the frozen pile of skis. Cyane looks at the moon, he is smiling. She grasps Kore's hand tighter and throws 
        her torch into the pile.</p>
      
      <p>“Please don’t ever leave me.”</p>
    </div>
  );
}

export default Incline;
